<template>
  <div class="overlay" @click="$emit('close')">
    <div class="dialog" @click.stop>
      <h3 class="title">Solicitar cambio de fecha</h3>
      <!-- RN-05: la original nunca se mueve. Se muestra para que quede claro
           que el compromiso inicial se conserva como evidencia. -->
      <p class="hint">
        La fecha original ({{ fmtFecha(plan.fechaCompromisoOriginal) }}) se
        conserva. Tu gerente debe aprobar el cambio antes de que surta efecto.
      </p>

      <label class="field">
        <span class="field-label">Fecha vigente</span>
        <input :value="fmtFecha(plan.fechaCompromiso)" class="inp" disabled />
      </label>

      <label class="field">
        <span class="field-label">Nueva fecha propuesta</span>
        <input v-model="f.fechaPropuesta" type="date" class="inp" />
        <span v-if="errores.fechaPropuesta" class="field-error">
          {{ errores.fechaPropuesta }}
        </span>
      </label>

      <label class="field">
        <span class="field-label">Motivo</span>
        <textarea
          v-model="f.motivo"
          rows="3"
          class="inp"
          placeholder="Por qué no se puede cumplir la fecha comprometida"
        ></textarea>
        <span v-if="errores.motivo" class="field-error">{{ errores.motivo }}</span>
      </label>

      <p v-if="error" class="error">{{ error }}</p>

      <div class="acciones">
        <button class="btn cancel" @click="$emit('close')">Cancelar</button>
        <button
          class="btn confirm"
          :disabled="busy"
          :style="{ background: busy ? '#cbd5e1' : '#003ca5' }"
          @click="enviar"
        >
          {{ busy ? "Enviando…" : "Enviar solicitud" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { fmtFecha } from "../cx.rules";
import { validaCambioFecha } from "../cx.validators";

export default {
  name: "CambioFechaModal",
  props: {
    plan: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["confirm", "close"],
  data() {
    return { errores: {}, f: { fechaPropuesta: "", motivo: "" } };
  },
  methods: {
    fmtFecha,
    enviar() {
      if (this.busy) return;
      const r = validaCambioFecha(this.f);
      this.errores = r.errores;
      if (!r.ok) return;
      this.$emit("confirm", { ...this.f });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.dialog {
  width: 100%;
  max-width: 440px;
  background: var(--pt-card, #fff);
  color: var(--pt-text, #0f172a);
  border-radius: 16px;
  padding: 20px;
}
.title {
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 6px;
}
.hint {
  font-size: 13px;
  color: var(--pt-dim);
  margin: 0 0 12px;
}
.field {
  display: block;
  margin-bottom: 12px;
}
.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--pt-dim);
  margin-bottom: 4px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
  resize: none;
}
.inp:focus {
  border-color: #003ca5;
}
.inp:disabled {
  background: var(--pt-elev);
  color: var(--pt-dim);
}
.field-error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #b91c1c;
}
.error {
  margin: 4px 0 0;
  font-size: 13px;
  color: #b91c1c;
}
.acciones {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.cancel {
  background: var(--pt-track);
  color: var(--pt-dim);
}
.confirm {
  color: #fff;
}
.confirm:disabled {
  cursor: not-allowed;
}
</style>
